import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const partnerWebhookLogsApi = createApi({
  reducerPath: 'partnerWebhookLogsApi',
  baseQuery: createBaseQuery('partner_webhook_logs'),
  endpoints: builder => ({
    getPartnerWebhookLogs: builder.query({
      query: params => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    resendPartnerWebhookLog: builder.mutation({
      query: id => ({
        url: `/${id}/resend`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useLazyGetPartnerWebhookLogsQuery, useResendPartnerWebhookLogMutation } =
  partnerWebhookLogsApi;
